import {
  DO_NOT_EXPORT,
  AWAITING_DECISION,
  NOT_SUBMITTED,
  DEFAULT_VALUE,
} from '$utils/overrideConstants';
import overrideOptions from '$utils/overrideOptions';

const getOverrideOptions = ({ studentGrade, hasAwaitingDecision }) => [
  ...(hasAwaitingDecision
    ? [
        {
          name: overrideOptions[AWAITING_DECISION],
          value: AWAITING_DECISION,
        },
      ]
    : []),
  {
    name: overrideOptions[NOT_SUBMITTED],
    value: NOT_SUBMITTED,
  },
  ...(studentGrade && studentGrade.displayGrade
    ? [
        {
          name: studentGrade.displayGrade,
          value: DEFAULT_VALUE,
        },
      ]
    : []),
  {
    name: overrideOptions[DO_NOT_EXPORT],
    value: DO_NOT_EXPORT,
    hasLightText: true,
  },
];

export default getOverrideOptions;
